import {ApplicationLocale} from 'src/js/common/types';

export const I18N_REDUCER_STATE_ID = 'i18n';
export const DEFAULT_LOCALE: ApplicationLocale = 'en';

export const CORE_MESSAGES_ID = 'core';
export const APP_MESSAGES_ID = 'app';
